import React from "react"

export default React.createContext({
  comments: [],
  sentiment: null,
  bookmark: null,
  commentsFilters: {},
  allBookmarks: [],
  loading: false,
  total: 0,
  page: 0,
  onPageChange: () => null,
  updateFilter: () => null
})
